import React, { Component, Fragment } from 'react';
import ServicePriceTableRow from './ServicePriceTableRow';

class ServicePriceTable extends Component {
    constructor(props) {
        super(props);
    }

    jobTypesExtraColumns = () => {
        if (this.props.table === 'jobTypes' && this.props.model === 'customer') {
            return (
                <Fragment>
                    <th>Custom SLA</th>
                    <th>Wasted Journey Fee</th>
                </Fragment>
            );
        }
        return null;
    };
    render() {
        const { heading } = this.props;
        const { table, tableTypes } = this.props;

        return (
            <Fragment>
                <h6 className="py-2 pl-2 cw-bg-grey text-white">{heading}</h6>
                <hr className="my-0" />
                <table className="table table-striped table-sm transform-text">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Price</th>
                            {this.jobTypesExtraColumns()}
                            <th>Active</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableTypes.map((data) => {
                            let error = this.props.errors.findIndex((error) => error.id === data.id);
                            return (
                                <ServicePriceTableRow
                                    key={data.id}
                                    rowData={data}
                                    table={table}
                                    customerSla={this.props.customerSla}
                                    handleJobExtrasChange={this.props.handleJobExtrasChange}
                                    model={this.props.model}
                                    error={this.props.errors[error] || ''}
                                    readOnly={this.props.readOnly}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </Fragment>
        );
    }
}

export default ServicePriceTable;
